import { useQueryClient } from '@tanstack/react-query';
import { keys } from '@blimo/api-client';
import { documentCheckSteps, formatNumber } from '@blimo/shared';

/** Label of the furthest step the API reports as done (list badge). @param {any} check */
export function lastDoneStep(check) {
  const { steps } = documentCheckSteps(check);
  return [...steps].reverse().find((s) => s.done) ?? steps[0];
}

/** Years offered in the list filter (UI choice only – the API filters). @param {Date} [today] */
export function fiscalYearOptions(today = new Date()) {
  const current = today.getFullYear();
  return Array.from({ length: 12 }, (_, i) => String(current + 1 - i)).map((y) => ({ value: y, label: y }));
}

/** Invalidates everything of the document checks (detail incl. comments, lists). */
export function useInvalidateCheck() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: keys.admin.resource('document-checks') });
}

/** Toast text after a sending action (`{ recipients }` from the API). @param {any} result */
export const recipientsText = (result) => `Versand an ${formatNumber(result?.recipients ?? 0)} Empfänger eingereiht`;
